import { useEffect, useRef, useState } from "react";
import { useInView, useReducedMotion } from "framer-motion";

// Eased count-up from 0 to `end` on first scroll-into-view. Suffix stays static.
export const CountUp = ({
  end,
  decimals = 0,
  suffix = "",
  duration = 1.7,
  decimalSep = ",",
  className,
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  const reduce = useReducedMotion();
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    if (reduce) {
      setVal(end);
      return;
    }
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min((now - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setVal(end * eased);
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, end, reduce, duration]);

  const display =
    decimals > 0 ? val.toFixed(decimals).replace(".", decimalSep) : Math.round(val).toString();

  return (
    <span ref={ref} className={className}>
      {display}
      {suffix}
    </span>
  );
};
